module.exports = __webpack_public_path__ + "static/img/av-logo-text.33e13ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/av-logo-text.png
// module id = 6VrA
// module chunks = 0